import { STATUS } from "../components/constants/statuses";
import { formatDate } from "../utils/formatDate";
import { addNotification } from "./notificationService";

export const checkAndAddStatusNotifications = (
  fetchedRequests,
  userId,
  dj = false
) => {
  const storedStatusesKey = `ticketStatuses_${userId}`;
  const storedStatuses =
    JSON.parse(localStorage.getItem(storedStatusesKey)) || {};
  const storedIds = new Set(
    JSON.parse(localStorage.getItem(`ticketIds_${userId}`)) || []
  );

  fetchedRequests.forEach((req) => {
    const prevStatus = storedStatuses[req.id];

    if (dj) {
      const notification = {
        id: req.updatedAt,
        message: "",
        date: formatDate(req.updatedAt) || "",
        read: false,
      };

      notification.trackName = req.trackName;
      notification.artist = req.artist;

      if (!storedIds.has(req.id)) {
        notification.type = STATUS.PENDING;
        notification.message = "You have a new request";
        addNotification(userId, notification);
      } else if (prevStatus && prevStatus !== req.status) {
        if (req.status === STATUS.PAID) {
          notification.type = STATUS.PAID;
          notification.message = "Request was paid";
          addNotification(userId, notification);
        }
      }

      storedIds.add(req.id);
    } else {
      if (prevStatus && prevStatus !== req.status) {
        const notification = {
          id: req.updatedAt,
          message: "",
          date: formatDate(req.updatedAt) || "",
          comment: req.djMessage,
          read: false,
        };

        notification.trackName = req.trackName;
        notification.artist = req.artist;

        if (req.status === STATUS.APPROVED) {
          const paymentLink = req.transaction.paymentLink || "#";
          notification.type = STATUS.APPROVED;
          notification.message = "Your request was approved";
          notification.link = `<a href="${paymentLink}" target="_blank" class="text-accent underline flex items-center space-x-1"> <CreditCard size="14" /> <span>[Pay]</span> </a>`;
          addNotification(userId, notification);
        } else if (req.status === STATUS.REJECTED) {
          notification.type = STATUS.REJECTED;
          notification.message = "Your request was rejected";
          addNotification(userId, notification);
        } else if (req.status === STATUS.PLAYED) {
          notification.type = STATUS.PLAYED;
          notification.message = "Your request was played";
          addNotification(userId, notification);
        }
      }
    }

    storedStatuses[req.id] = req.status;
  });

  localStorage.setItem(storedStatusesKey, JSON.stringify(storedStatuses));
  localStorage.setItem(`ticketIds_${userId}`, JSON.stringify([...storedIds]));
};
